import { isUndefined } from 'lodash-es';
import { useContext } from 'react';

import { HistogramAnnotationsConfigContext } from '../contexts/HistogramAnnotationsConfig.context.js';

export const useHistogramAnnotationsConfig = () => {
  const context = useContext(HistogramAnnotationsConfigContext);
  if (isUndefined(context)) {
    throw new Error(
      'useHistogramAnnotationsConfig must be used within a HistogramAnnotationsConfigContext',
    );
  }
  return context;
};
